import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import employees from 'modules/employees/store/collections/employees'
import type Issue from 'modules/payroll_bundle/store/models/Issue'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

import type { PaymentItemLikeMinimal } from 'modules/payroll_bundle/pages/ResultsAndPaymentsPage/PaymentsPage/GeneratePaymentsPage/Table/useDraftPaymentItemsDataCollectionSource'

type ItemWithEmployee = Supplement | PaymentItem | Issue | PaymentItemLikeMinimal

const getUserByItem = (item: ItemWithEmployee): User | null | undefined => {
  const employee = employees.get(item.attributes.employee_id)

  if (employee) {
    const userId = employee.attributes.access_id
    const user = users.get(userId)
    if (!user) {
      throw Error(`Error getting users with id = ${userId}`)
    }
    return user
  }

  if (item.has('userId') && item.attributes.userId != null) {
    return users.find({ user_id: item.attributes.userId })
  }

  return null
}

export default getUserByItem
